import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _typeof from "@babel/runtime-corejs2/helpers/esm/typeof";
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import nextReduxWrapper from 'next-redux-wrapper';
import createReducer from '../reducers';
var sagaMiddleware = createSagaMiddleware();
var middlewares = [sagaMiddleware];
var enhancers = [applyMiddleware.apply(void 0, middlewares)]; // Choose compose method depending upon environment and platform

var composeEnhancers = process.env.NODE_ENV !== 'production' && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? composeWithDevTools : compose;
var globalSaga;
/**
 * This utility set global saga of application
 * @param {Function} sagas
 */

export var initialiseGlobalSagas = function initialiseGlobalSagas(sagas) {
  globalSaga = sagas;
};
/**
 * Create redux store with the middlewares and enhancers
 *
 * @param {Object} options
 * @param {Object} options.key - Unique key to recognize the page component
 * @param {Object} options.reducer - Reducers associated with the page component
 * @param {Object} options.saga - Sagas associated with the page component
 */

export default (function (options) {
  return function (BaseComponent) {
    var hasKey = !!options.key; // $FlowFixMe eslint-disable-line

    if (!hasKey) throw new Error("".concat(BaseComponent.displayName, " needs to be passed with a key"));
    var hasReducer = !!options.reducer;
    var hasSaga = !!options.saga;
    var reducer = hasKey && hasReducer ? _defineProperty({}, options.key, options.reducer) : {};

    var configureStore = function configureStore() {
      var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var store = createStore(createReducer(reducer), initialState, composeEnhancers.apply(void 0, enhancers)); // Keep access to 'run' method of saga task in store so thats its available globally with store
      // $FlowFixMe eslint-disable-line

      store.runSaga = sagaMiddleware.run; // Keep record of reducer injected in store associated with unique key
      // $FlowFixMe eslint-disable-line

      store.injectedReducers = reducer;

      if (globalSaga) {
        // Run global saga and keep the task returned by running saga to access later while cancelling
        // $FlowFixMe eslint-disable-line
        store.globalSaga = {
          globalSaga: globalSaga,
          task: store.runSaga(globalSaga)
        };
      } // Keep record of saga injected in store associated with unique key
      // $FlowFixMe eslint-disable-line


      store.injectedSagas = {};

      if (hasSaga) {
        // Run saga and keep the task returned by running saga to access later while cancelling.
        // $FlowFixMe eslint-disable-line
        store.injectedSagas[options.key] = _objectSpread({}, options.saga, {
          task: store.runSaga(options.saga)
        });
      }

      return store;
    };

    return nextReduxWrapper(configureStore)(BaseComponent);
  };
});